var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 18,
    viewBox: "0 0 25 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6212 0.29248L24.8945 17.2465H0.347901L12.6212 0.29248Z",
    fill: "#EFF1F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopArrow);
export default __webpack_public_path__ + "static/media/topArrow.9581f28ae89a386955a34a469e65c82f.svg";
export { ForwardRef as ReactComponent };